import {autoserialize, autoserializeAs, inheritSerialization} from 'cerialize';
import {ChecklistItemType} from './checklist-item-type';
import {ChecklistItemTypeTransformer} from '../helpers/enum/checklist-item-type-transformer';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class ChecklistItem extends ModelBase {
  public static readonly type = 'ChecklistItem';
  public readonly type = ChecklistItem.type;

  @autoserialize
  public id: number;

  @autoserializeAs(ChecklistItemTypeTransformer, 'item')
  public item: ChecklistItemType;

  public checked = false;
}
